import { StyleSheet } from 'aphrodite';
import { brandSecondary } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	content: {
		display: 'flex',
		flexDirection: 'column',
		gap: 10,
		maxWidth: 300,
	},
	description: {
		fontSize: 14,
	},
	body: {
		marginBottom: 30,
	},
	container: {
		minWidth: 460,
	},
	footer: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'flex-end',
		marginTop: 20,
		gap: 10,
	},
	header: {
		color: brandSecondary,
		fontSize: 18,
	},
});
